import React from 'react'

const Footer = () => {
    return (
        <footer className="main-footer">
            <div className="footer-links">
                <a href="/about">எங்களைப் பற்றி &#8599; </a>
                <a href="/contact">தொடர்பு கொள்ள &#8599; </a>
                <a href="/privacy">தனியுரிமைக் கொள்கை &#8599; </a>
                <a href="/terms">பயன்பாட்டு விதிமுறைகள் &#8599; </a>
            </div>
            <div className="copyright">
                © {new Date().getFullYear()} Lookit. All rights reserved.
            </div>
        </footer>
    )
}

export default Footer